import './app.css';
import '../shared/styles/attention-ring.css';
import { LoadingProvider, useLoading } from './providers/loadingContext';
import { setLoadingManager } from '../services/api/axiosInstance';
import React, { lazy, Suspense } from 'react';
import { UserProvider, useUser } from './providers/userContext';
import { AppStateProvider } from './providers/appStateContext';
import ToastProvider from '../shared/notifications/toastProvider';
import Routers from './routing/Routers';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthInitializer from './bootstrap/AuthInitializer';
import SessionExpiryRedirect from './bootstrap/SessionExpiryRedirect';
import AppErrorBoundary from '../shared/components/common/AppErrorBoundary';

const SchoolAIWidget = lazy(() => import('../features/ai-assistant/pages/SchoolAIWidget'));

function AuthenticatedAIWidget() {
  const { user } = useUser();
  return user ? (
    <Suspense fallback={null}>
      <SchoolAIWidget />
    </Suspense>
  ) : null;
}

function LoadingManagerConnector() {
  const loadingManager = useLoading();

  React.useEffect(() => {
    setLoadingManager(loadingManager);
  }, [loadingManager]);

  return null;
}

function App() {
  return (
    <AppErrorBoundary>
      <LoadingProvider>
        <LoadingManagerConnector />
        <AppStateProvider>
          <UserProvider>
            <Router>
              <SessionExpiryRedirect />
              <AuthInitializer>
                <Routers />
                <AuthenticatedAIWidget />
              </AuthInitializer>
            </Router>
            <ToastProvider />
          </UserProvider>
        </AppStateProvider>
      </LoadingProvider>
    </AppErrorBoundary>
  );
}

export default App;
